<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { useBreakpoints } from "@vueuse/core";

const { data: sessionData, status } = useAuth();

const breakpoints = useBreakpoints(BREAKPOINTS);
const isMobile = breakpoints.smaller("laptop");

const compareCount = ref(0);

const updateCompareCount = () => {
  try {
    const raw = localStorage.getItem("compare-program");
    const parsed = raw ? JSON.parse(raw) : [];
    compareCount.value = Array.isArray(parsed) ? parsed.length : 0;
  } catch (e) {
    console.error("Invalid compare-program data:", e);
    compareCount.value = 0;
  }
};

const gotoCompare = () => {
  if (status.value !== "authenticated") return;
  navigateTo("/compare");
};

onMounted(() => {
  updateCompareCount();
  window.addEventListener("compare-program-updated", updateCompareCount);
});

onBeforeUnmount(() => {
  window.removeEventListener("compare-program-updated", updateCompareCount);
});
</script>

<template>
  <div v-if="isMobile">
    <div
      class="flex items-center cursor-pointer relative"
      @click="navigateTo('/compare')"
      :class="{
        'text-blue-500 font-semibold': $route.path === '/compare',
      }"
    >
      <i class="cursor-pointer pi pi-compass text-lg"></i>
      <span class="ml-2.5">Comparison</span>
      <Badge v-if="compareCount" size="small">
        {{ compareCount }}
      </Badge>
    </div>
  </div>

  <ProfileCompleteGuard @on-callback="gotoCompare" v-else>
    <Button
      label="Comparison"
      text
      icon="pi pi-compass"
      class="text-white"
      size="small"
      severity="secondary"
      :badge="compareCount"
      @click="gotoCompare"
    />
  </ProfileCompleteGuard>
</template>
